// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboRelatorios_ClienteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de GET /so/combo_relatorios/cliente/{cliente_id} (NS 2026-0090,
 * fatia 4): as compras de combo do cliente, mais nova primeiro, cada uma com
 * saldo, pagamento da OS da venda e historico de movimentos.
 */
import type { ComboRelatorios_CompraRow } from './ComboRelatorios_CompraRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ComboRelatorios_ClienteResponseDados {
cliente_id: number
compras: ComboRelatorios_CompraRow[]
}

export type ComboRelatorios_ClienteResponse = ApiResponse<ComboRelatorios_ClienteResponseDados>;

registerResponseContract('ComboRelatorios_ClienteResponse', {
  cliente_id: { type: 'number',  required: true },
  compras: {
    type: 'array',
    required: true,
    items: {
      compra_id:           { type: 'number',  required: true },
      combo_id:            { type: 'number',  required: true },
      combo_nome:          { type: 'string',  required: true },
      service_id:          { type: 'number',  required: true },
      priority_id:         { type: 'number',  required: true },
      franquia_id:         { type: 'number',  required: true },
      order_id:            { type: 'number',  required: true },
      order_item_id:       { type: 'number',  required: true },
      quantidade:          { type: 'number',  required: true },
      preco_total:         { type: 'number',  required: true },
      validade_dias:       { type: 'number',  required: false },
      expires_at:          { type: 'string',  required: false },
      vencida:             { type: 'boolean', required: false },
      status:              { type: 'string',  required: true },
      motivo_cancelamento: { type: 'string',  required: false },
      cancelled_by:        { type: 'string',  required: false },
      cancelled_at:        { type: 'string',  required: false },
      created_at:          { type: 'string',  required: true },
      disponivel:          { type: 'number',  required: true },
      reservado:           { type: 'number',  required: true },
      consumido:           { type: 'number',  required: true },
      situacao_financeira: { type: 'string',  required: true },
      venda_total:         { type: 'number',  required: true },
      venda_recebido:      { type: 'number',  required: true },
      venda_status:        { type: 'string',  required: false },
      movimentos: {
        type: 'array',
        required: false,
        items: {
          movimento_id:        { type: 'number',  required: true },
          compra_id:           { type: 'number',  required: true },
          combo_id:            { type: 'number',  required: true },
          combo_nome:          { type: 'string',  required: true },
          cliente_id:          { type: 'number',  required: true },
          cliente_nome:        { type: 'string',  required: true },
          tipo:                { type: 'string',  required: true },
          quantidade:          { type: 'number',  required: true },
          order_id:            { type: 'number',  required: false },
          order_item_id:       { type: 'number',  required: false },
          preco_matriz:        { type: 'number',  required: false },
          origem_movimento_id: { type: 'number',  required: false },
          motivo:              { type: 'string',  required: false },
          usuario_id:          { type: 'string',  required: false },
          created_at:          { type: 'string',  required: true },
        },
      },
    },
  },
})
